import { render, staticRenderFns } from "./DetailReport.vue?vue&type=template&id=46a178f8&"
import script from "./DetailReport.vue?vue&type=script&lang=js&"
export * from "./DetailReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports